export const DEFAULT_TITLE = 'Загрузка...';
export const DEFAULT_RECT_RADIUS = 16;
export const DEFAULT_HEIGHT = 24;
export const DEFAULT_WIDTH = 200;
export const FOREGROUND_COLOR = '#f5f5f5';
export const BACKGROUND_COLOR = '#E8E8E8';
